var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainTitle",style:({textAlign: _vm.msgObj.horizontal ? _vm.msgObj.horizontal : 'center'})},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.msgObj.title1))]),_vm._v(" "),_c('span',[_vm._v("____")]),_vm._v(" "),_c('p',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.msgObj.title2)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bf8984","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DAWNING/titleContent.vue
// module id = null
// module chunks = 